import React from 'react';

import PropTypes from 'prop-types';
import { Header, Segment, Button, Message, Label } from 'semantic-ui-react';

import {
  getInfoText,
  getDelayUnit,
  getDelayAmount,
  getApprovedByEmail,
} from './PreparedResponse.utils';
import { reviewResponseShape } from '../../../../types';
import ResponseDatetime from '../ResponseDatetime/ResponseDatetime';

import './PreparedResponse.scss';

const propTypes = {
  reviewResponse: reviewResponseShape.isRequired,
  isEditing: PropTypes.bool.isRequired,
  isPending: PropTypes.bool.isRequired,
  setReplyText: PropTypes.func.isRequired,
  setIsEditing: PropTypes.func.isRequired,
  isSubmitted: PropTypes.bool.isRequired,
};

const defaultProps = {};

export default function PreparedResponse({
  reviewResponse,
  isEditing,
  isPending,
  setReplyText,
  setIsEditing,
  isSubmitted,
}) {
  if (!reviewResponse || isEditing) return null;

  const { content, submittedAt, statusDisplay, publishAt } = reviewResponse;
  const delayUnit = getDelayUnit(reviewResponse);
  const delayAmount = getDelayAmount(reviewResponse);
  const approvedByEmail = getApprovedByEmail(reviewResponse);
  const infoText = getInfoText(reviewResponse, delayUnit, delayAmount);
  const showMessage = isPending && infoText;

  function handleEditClick() {
    setReplyText(content || '');
    setIsEditing(true);
  }

  return (
    <div className="prepared-response">
      {isSubmitted ? <Header>Published Response</Header> : <Header>Prepared Response</Header>}
      <Segment attached={!!showMessage}>
        <div className="review-meta">
          <span className="response-review-status">
            <Label basic>{statusDisplay}</Label>
          </span>

          {(submittedAt || publishAt) && (
            <span className="response-review-date">
              <ResponseDatetime submittedAt={submittedAt} publishAt={publishAt} />
            </span>
          )}
        </div>
        {!!approvedByEmail && (
          <span className="review-approved-by">Approved by: {approvedByEmail}</span>
        )}
        <div className="response-review-text">{content}</div>

        {!isSubmitted && (
          <div className="prepared-response-actions">
            <Button basic onClick={handleEditClick} icon="pencil" content="Edit" />
          </div>
        )}
      </Segment>
      {showMessage && (
        <Message attached="bottom" info>
          {infoText}
        </Message>
      )}
    </div>
  );
}

PreparedResponse.propTypes = propTypes;
PreparedResponse.defaultProps = defaultProps;
